const getTreeName = function(treeList, id) {
  for (let i=0; i<treeList.length; i++) {
    let treeItem = treeList[i]
    if (treeItem.id === id) {
      return treeItem
    } else {
      if (treeItem.children && treeItem.children.length) {
        let res = getTreeName(treeItem.children, id)
        if (res) {
          return res
        }
      }
    }
  }
}

const genAnswer = function (qu, value, refItem) {
  let valueArr = []
  value.forEach((item, index) => {
    valueArr.push({
      id: item,
      parentId: index > 0 ? value[index - 1] : '',
      value: getTreeName(qu.optionList, item).value,
      optionCode: getTreeName(qu.optionList, item).optionCode,
      level: (index + 1)
    })
  })
  return [{
    descId: qu.id,
    answer: JSON.stringify(valueArr)
  }]
}

const setAnswer = function (qu, valueMap, otherAnswerMap, extendsDataMap) {
  const id = qu.id
  let value = valueMap[id] || ''
  qu.value = value
  qu.otherAnswer = otherAnswerMap[id] || ''
}

const answer = {
  genAnswer,
  setAnswer
}

export default answer



// WEBPACK FOOTER //
// ./src/components/editor/CascadeBox/answer.js